<template>
  <div id="divMasterPage" class="Flex_Table" :class="this.masterData.PageTheme">
    <nav id="navMenu" v-bind:class="navClass" v-if="!this.isDisplayFormOnly">
      <a
        class="glyphicons circle_remove btnMasterMenuTogglerMobile"
        @click="ToggleMenu"
      ></a>
      <div id="divLoginUserInfo">
        <div class="Flex_Table Wrap">
          <div class="Flex_Row" style="background: #488bda">
            <div class="Flex_Cell_Inline">
              <img
                style="height: 70px; margin: 5px"
                src="../assets/images/logo.png"
                alt="logoImg"
              />
            </div>
          </div>
        </div>
      </div>
      <div id="divMasterMenu" :class="this.masterData.PageThme">
        <ul>
          <li
            @click="NevigateForm('Application')"
            style="
              height: 40px;
              background-color: rgb(42, 128, 186);
              color: white;
            "
          >
            <span class="glyphicons BLACK" style="font-size: 18px"
              >Online Application</span
            >
          </li>
          <ul>
            <!-- <li
              v-for="ff in currentUser.userRights.formRole"
              :key="ff.formID"
              @click="RedirectToForm(ff.formID)"
            >{{ff.displayName}}</li>-->
          </ul>
        </ul>
      </div>
    </nav>
    <div id="MasterContainer" v-bind:class="this.masterData.PageThme">
      <header>
        <div class="Flex_Table">
          <div class="Flex_Row" style="padding-right: 10px">
            <div class="Flex_Cell_Inline" v-if="!this.isDisplayFormOnly">
              <a
                class="glyphicons justify"
                @click="ToggleMenu"
                title="Toggle Menu"
              ></a>
            </div>
            <div class="Flex_Cell_Inline" v-if="false">
              <a
                class="glyphicons brightness_increase"
                @click="ShowThemeSelectionMenu($event)"
                title="Theme"
              ></a>
              <div
                id="divThemeSelectorAndModifier"
                class="MasterPageDropDownMenu"
                :class="{ Open: MasterTitleMenu.index == 1 }"
                @click.stop
              >
                <div style="padding: 5px">
                  <h1>Select Module Color</h1>
                </div>
                <div class="Flex_Table" style="width: 600px">
                  <div class="Flex_Row">
                    <div class="Flex_Cell" width="50%" align="center">
                      Module
                      <div
                        style="
                          height: 250px;
                          background-color: black;
                          color: white;
                          overflow: auto;
                          border: solid 2px black;
                          padding: 5px;
                          border-radius: 5px;
                          text-align: left;
                          margin: 2px;
                        "
                        id="divModule_Theme"
                      >
                        <label
                          v-for="mm in this.userModules"
                          :key="mm.moduleID"
                          :class="mm.class"
                          style="display; padding:10px;border:solid 1px;font-size:110%;font-weight:bold;"
                        >
                          <input
                            type="radio"
                            name="rdModule"
                            :value="mm.moduleID"
                          />
                          {{ mm.moduleName }}
                        </label>
                      </div>
                    </div>
                    <div class="Flex_Cell" width="50%" align="center">
                      Theme Color
                      <div
                        style="
                          height: 250px;
                          background-color: black;
                          color: white;
                          overflow: auto;
                          border: solid 2px black;
                          padding: 5px;
                          border-radius: 5px;
                          text-align: left;
                          margin: 2px;
                        "
                      >
                        <label
                          v-for="tc in this.ThemeColors"
                          :key="tc"
                          :class="tc"
                          style="display: ; padding: 6px; border: solid 1px"
                        >
                          <input
                            type="radio"
                            name="rdThemeColor"
                            @click="SetModuleColor"
                            :value="tc"
                          />
                          {{ tc }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div align="center" style="padding: 5px">
                  <input
                    type="button"
                    value="Update Theme"
                    @click="UpdateUserThemeSettings"
                  />
                </div>
                <!-- <img src="../assets/images/temp/ThemeModify.png"> -->
              </div>
            </div>
            <div class="Flex_Cell_Inline">
              <a
                class="glyphicons home"
                @click="GoToHomePage"
                title="Go To Home Page"
              ></a>
            </div>
            <div
              class="Flex_Cell CurrentFormDisplayName"
              valign="middle"
              style="padding-left: 5px"
            >
              <span id="lblCurrentFormDisplayName">
                {{ this.masterData.FormDisplayName }}
              </span>
            </div>
            <div class="Flex_Cell_Inline">
              <a
                class="glyphicons circle_question_mark"
                @click="ShowHelpControl"
                title="Help"
              ></a>
              <div
                id="divHelpContainer"
                class="MasterPageDropDownMenu"
                :class="{ Open: MasterTitleMenu.index == 4 }"
                @click.stop
              >
                <div class="divHelpMenu">
                  <div class="Flex_Table">
                    <div class="Flex_Row">
                      <div class="Flex_Cell">
                        <span
                          id="lblHelpTitle"
                          style="font-size: 200%; font-weight: bold"
                          >{{ this.helpHeading }}</span
                        >
                        <br />
                        <span>{{ this.helpContent }}</span>
                      </div>
                      <div class="Flex_Cell" style="width: 30px">
                        <a
                          class="glyphicons remove"
                          v-on:click="hidePopUpWindow()"
                        ></a>
                      </div>
                    </div>
                    <div class="Flex_Row">
                      <div class="Flex_Cell">
                        <br />
                      </div>
                    </div>
                    <div class="Flex_Row" v-if="this.formHelpList">
                      <div class="Flex_Cell">
                        <div id="divHelpTopic">
                          <div class="Flex_Table ekkGrid">
                            <div class="Flex_Row GridHeader">
                              <div class="Flex_Cell">Topic Name</div>
                              <div class="Flex_Cell" style="width: 30px"></div>
                            </div>
                            <div
                              class="Flex_Row"
                              v-for="ht in this.formHelpList"
                              v-bind:key="ht.helpTopicID"
                            >
                              <div class="Flex_Cell" valign="middle">
                                <a
                                  v-on:click="downLoadFiles(ht)"
                                  style="width: 100%"
                                  >{{ ht.topicName }}</a
                                >
                              </div>
                              <div class="Flex_Cell" style="width: 30px">
                                <img
                                  src="../assets/images/mp4.png"
                                  v-if="ht.topicTypeID == 2"
                                />
                                <img src="../assets/images/pdf.png" v-else />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="Flex_Row">
                      <div class="Flex_Cell" align="center">
                        <span class="helpContact headtitle"
                          >For any queries write email to
                        </span>
                        <br /><span class="helpContact"
                          ><img href="#" src="../assets/images/mail-id.png" alt="helpEmailImg" />
                        </span>
                        <!-- <br /><span class="helpContact"> or contact 020-26716117 or 020-26716000 </span>
                        <br /><span class="helpContact">(Monday to Friday - 10 am to 5 pm)</span> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="Flex_Cell_Inline" v-if="false">
              <a
                class="glyphicons cogwheel"
                @click="ShowUserSettingsControl"
                title="Settings"
              ></a>
              <div
                id="divUserSettingsContainer"
                class="MasterPageDropDownMenu"
                :class="{ Open: MasterTitleMenu.index == 6 }"
                @click.stop
              >
                <img src="../assets/images/temp/userSettings.png" />
              </div>
            </div>
            <div
              class="Flex_Cell_Inline WelcomeUserName"
              style="white-space: nowrap; padding: 5px"
              valign="middle"
            >
              <span>Welcome !! &nbsp; {{ currentUser.userName }}</span>
            </div>
            <div class="Flex_Cell_Inline" v-if="!this.isDisplayFormOnly">
              <a
                class="glyphicons refresh"
                @click="RefreshPage"
                title="Refresh"
              ></a>
            </div>
            <div class="Flex_Cell_Inline">
              <a class="glyphicons power" @click="LogOut"></a>
            </div>
          </div>
        </div>
      </header>
      <content>
        <router-view></router-view>
      </content>
      <footer>
        <div class="Flex_Table FooterTable">
          <div class="Flex_Row">
            <div class="Flex_Cell_Inline">
              <a href="#" target="_blank">
                <!-- <img src="../assets/images/nibmFooter.png" align="left" /> -->
                <img
                  src="../assets/images/mainFooter.png"
                  align="left"
                  style="height: 42px"
                  alt="footerImg"
                /> </a
              ><a                
                href="http://www.eklavya.com"
                target="_blank"
                >.
                <!-- <img src="../assets/images/footer-logo.png" align="left" /> -->
              </a>
            </div>
            <div class="Flex_Cell FooterMessage" valign="middle" align="center">
              <span>{{ masterData.FooterMessage }}</span>
            </div>
            <div class="Flex_Cell_Inline">
              <!-- <a
                style="color:white"
                href="http://www.eklavya.com"
                target="_blank"
                >.
                <img src="../assets/images/footer-logo.png" align="left" /> 
              </a> -->
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
import vue from "vue";
import router from "vue-router";
import axios from "axios";
import config from "@/router/globalConfig";
export default {
  name: "Master",
  data() {
    return {
      currentUser: {
        userName: "",
        lastLoginAttempt: "",
        userRights: [],
        connection: null
      },
      masterData: {
        IsMenuOpen: true,
        PageThme: "AAADTheme",
        FormID: -1,
        FormName: "Home",
        FormDisplayName: "Home",
        FooterMessage: "Best Viewed in Chrome / FireFox",
        moduleID: -1
      },
      userModules: [{ moduleID: -1, moduleName: "Home", class: "AAADTheme" }],
      MasterTitleMenu: { index: 0 },
      formHelpList: null,
      helpHeading: "",
      helpContent: "",
      packageID: 2,
      isDisplayFormOnly: true
    };
  },
  methods: {
    NevigateForm(objRoute) {
      if (objRoute.split("/").length > 1) {
        objRoute = objRoute.split("/")[0];
      }
      this.$router.push({ name: objRoute });
      this.masterData.IsMenuOpen = false;
    },
    CheckAuthentication() {
      const authToken = config.LOG_Token;
      const antiforgeryToken = config.AF_Token;
      axios
        .get(config.WEB_API_PATH + "Login/CheckAuthentication", {
          headers: {
            __RequestVerificationToken: antiforgeryToken,
            Authorization: authToken
          },
          params: { PackageID: this.packageID, Type: 1 },
          crossdomain: true
        })
        .then(
          result => {
            window.sessionStorage.setItem(
              "antiforgery_token",
              result.data.result5
            );
            config.AF_Token = window.sessionStorage.getItem(
              "antiforgery_token"
            );
            this.GetLoggedUserDetails();
          },
          error => {
            //alert("Error: " + error);
          },
          failure => {
            //alert("Failure: " + failure);
          }
        )
        .catch(function(error) {
          this.LogOut();
        });
    },
    GetLoggedUserDetails() {
      const authToken = "bearer ".concat(
        window.sessionStorage.getItem("token")
      );

      const antiforgeryToken = window.sessionStorage.getItem(
        "antiforgery_token"
      );
      axios
        .get(config.WEB_API_PATH + "Login/GetCurrentUser", {
          headers: {
            __RequestVerificationToken: antiforgeryToken,
            Authorization: authToken
          },
          params: {},
          crossdomain: true
        })
        .then(
          result => {
            config.CurrentUser = result.data;
            this.currentUser = result.data;
          },
          error => {
            alert("Error: " + error);
          },
          failure => {
            alert("Failure: " + failure);
          }
        )
        .catch(function(error) {
          alert(error);
          this.LogOut();
        });
    },
    ToggleMenu() {
      this.masterData.IsMenuOpen = !this.masterData.IsMenuOpen;
    },
    ShowThemeSelectionMenu(e) {
      e.stopPropagation();
      this.MasterTitleMenu.index = this.MasterTitleMenu.index == 1 ? 0 : 1;
    },
    ToggleMenuModule(e) {
      let obj = e.target.closest("li");
      document
        .querySelectorAll("#divMasterMenu ul.Open")
        .not(obj.parentNode)
        .removeClass("Open");
      obj.parentNode.toggleClass("Open");
    },
    SetModuleColor(e) {
      let theme = e.target.value;
      let selModule = document.querySelector(
        "#divModule_Theme input[type='radio']:checked"
      );
      if (selModule) {
        let moduleID = selModule.value;
        for (let i = 0; i < this.userModules.length; i++) {
          if (this.userModules[i].moduleID == moduleID) {
            this.userModules[i].class = theme;
          }
        }
      }
    },
    UpdateUserThemeSettings() {
      let menuModule = this.currentUser.userRights.menuModule;
      for (let i = 0; i < this.userModules.length; i++) {
        for (let j = 0; j < menuModule.length; j++) {
          if (this.userModules[i].moduleID == menuModule[j].moduleID) {
            menuModule[j].class = this.userModules[i].class;
          }
        }
      }
      let ModuleTheme = "";
      for (let i = 0; i < this.userModules.length; i++) {
        ModuleTheme +=
          "," + this.userModules[i].moduleID + "|" + this.userModules[i].class;
        if (this.masterData.moduleID == this.userModules[i].moduleID) {
          this.masterData.PageThme = this.userModules[i].class;
        }
      }
      if (ModuleTheme) {
        ModuleTheme = ModuleTheme.substring(1);
      }
      const authToken = "bearer ".concat(
        window.sessionStorage.getItem("token")
      );
      const antiforgeryToken = window.sessionStorage.getItem(
        "antiforgery_token"
      );
      axios
        .get(config.WEB_API_PATH + "ManageUser/UpdateUserMenuTheme", {
          headers: {
            __RequestVerificationToken: antiforgeryToken,
            Authorization: authToken
          },
          params: {
            ModuleTheme: ModuleTheme,
            Type: 1
          },
          crossdomain: true
        })
        .then(
          result => {},
          error => {
            alert("Error: " + error);
          },
          failure => {
            alert("Failure: " + failure);
          }
        )
        .catch(function(error) {
          alert(error);
        });
    },
    GoToHomePage() {
      //if (this.currentUser.isSubmit) {
      this.masterData.IsMenuOpen =
        document.querySelector("html").offsetWidth > 600;
      this.masterData.FormID = -1;
      this.masterData.FormName = "Home";
      this.masterData.FormDisplayName = "Home";
      this.masterData.PageThme = "AAADTheme";
      this.masterData.moduleID = -1;
      this.NevigateForm("Home");
      //}
    },
    ShowHelpControl(e) {
      e.stopPropagation();
      this.MasterTitleMenu.index = this.MasterTitleMenu.index == 4 ? 0 : 4;
      // this.getFormHelp();
    },
    ShowUserSettingsControl(e) {
      e.stopPropagation();
      this.MasterTitleMenu.index = this.MasterTitleMenu.index == 6 ? 0 : 6;
    },
    RefreshPage() {
      location.reload();
    },
    LogOut() {
      axios
        .post(config.WEB_API_PATH + "Login/Logout", "", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token
          }
        })
        .then(
          response => {
            if (this.connection != null) {
              this.connection.stop();
            }
            window.sessionStorage.clear();
            //this.NevigateForm("Login");
            //this.$router.go("Login");
            this.$root.$data.sessionPage = 1;
            this.$router.push({ name: "Login" });
          },
          error => {
            if (this.connection != null) {
              this.connection.stop();
            }
            window.sessionStorage.clear();
            //this.NevigateForm("Login");
            //this.$router.go("Login");
            this.$root.$data.sessionPage = 1;
            this.$router.push({ name: "Login" });
          },
          failure => {}
        );
    },
    // RedirectToForm(formID) {
    //   this.MasterTitleMenu.index = 0;
    //   let RedirectForm = null;
    //   let formRole = this.currentUser.userRights.formRole;
    //   for (let i = 0; i < formRole.length; i++) {
    //     if (formRole[i].formID == formID) {
    //       RedirectForm = formRole[i];
    //       break;
    //     }
    //   }
    //   if (RedirectForm) {
    //     this.masterData.IsMenuOpen =
    //       document.querySelector("html").offsetWidth > 600;
    //     this.masterData.FormID = formID;
    //     this.masterData.FormDisplayName = RedirectForm.displayName;
    //     this.masterData.FormName = RedirectForm.formName;
    //     this.masterData.moduleID = RedirectForm.moduleID;
    //     this.NevigateForm(RedirectForm.formName);
    //     window.formID = formID;
    //     this.masterData.IsMenuOpen = false;
    //   } else {
    //     this.GoToHomePage();
    //   }
    // },
    hidePopUpWindow() {
      this.MasterTitleMenu.index = 0;
    }
  },
  computed: {
    navClass() {
      if (this.masterData.IsMenuOpen) {
        return "Open";
      } else {
        return "";
      }
    },
    ThemeColors() {
      let tColors = [];
      for (let i = 1; i <= 29; i++) {
        tColors.push("Light color-" + i);
      }
      for (let i = 1; i <= 29; i++) {
        tColors.push("Dark color-" + i);
      }
      tColors.push("AAADTheme");
      return tColors;
    }
  },
  created: function() {
    if (window.sessionStorage.getItem("token") == null) {
      this.$root.$data.sessionPage = 1;
      this.$router.push({ name: "Login" });
    } else {
      if (window.sessionStorage.getItem("pkg")) {
        this.packageID = window.sessionStorage.getItem("pkg");
        window.sessionStorage.removeItem("pkg");
      }
      this.CheckAuthentication();
    }
  },
  mounted() {
    // if back button is pressed
    let me = this;
    window.onpopstate = function(event) {
      window.sessionStorage.clear();
      alert("Your session has expired. Please login again");
      me.$router.push({ name: "SessionExpire" });
    };
  }
};
</script>
<style scoped>
body {
  padding: 5px;
}
</style>
<style>
@import url("../assets/css/MasterPage_v1.0.css");
body {
  background-image: none;
}
.headtitle {
  background: #37758814;
}
.helpContact {
  background: #37758814;
  padding: 1px 16px;
  margin-left: 0;
  margin-right: 0;
  border-left: black solid 5px;
  border-right: solid 5px black;
  border-radius: 5px;
  min-height: 30px;
  line-height: 30px;
  font-size: medium;
  margin-bottom: 2px;
  width: 80%;
  display: inline-block;
}
.divHelpMenu {
  display: block;
  height: 250px;
  width: 500px;
  overflow: auto;
  padding: 5px;
  border-radius: 3px;
  border: solid 2px blue;
  background-color: aliceblue; /* rgba(168, 168, 168, 0.37);*/
}
.divFavMenu {
  display: block;
  overflow: auto;
  padding: 5px;
  border-radius: 3px;
  border: solid 2px blue;
  background-color: rgba(168, 168, 168, 0.37);
  height: 350px;
}
</style>



// WEBPACK FOOTER //
// src/components/Master.vue